import { render, staticRenderFns } from "./PopularPosts.vue?vue&type=template&id=4c988c8e&"
import script from "./PopularPosts.vue?vue&type=script&lang=js&"
export * from "./PopularPosts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports